import {Banner} from '@jetbrains/ring-ui-built/components/banner/banner'
import Link from '@jetbrains/ring-ui-built/components/link/link'
import * as React from 'react'

import styles from './WarmAgentsPromoBanner.module.css'

import {useSetUserProperty} from 'src/hooks/useSetUserProperty'
import {useBooleanUserProperty} from 'src/hooks/useUserProperty'
import {isCloud} from 'src/utils/featureToggles'
import {UserProperties} from 'src/utils/userProperties'

const WARM_AGENTS_PLUGIN_PAGE_URL = 'https://plugins.jetbrains.com/plugin/33276-warm-agents'
// TODO: set once the blogpost is published
const WARM_AGENTS_LEARN_MORE_URL: string | null = null

function getCloudInstallRequestUrl() {
  const params = new URLSearchParams({
    ticket_form_id: '360003300299',
    teamcity_cloud_url: window.location.hostname,
    product_type: 'teamcity_cloud',
  })
  return `https://teamcity-support.jetbrains.com/hc/en-us/requests/new?${params.toString()}`
}

const WarmAgentsPromoBanner = React.memo(() => {
  const setUserProperty = useSetUserProperty()
  const isShown = useBooleanUserProperty(UserProperties.SHOW_WARM_AGENTS_PROMO_BANNER, true)

  const dismiss = React.useCallback(
    () => setUserProperty(UserProperties.SHOW_WARM_AGENTS_PROMO_BANNER, 'false'),
    [setUserProperty],
  )

  if (!isShown) {
    return null
  }

  const installHref = isCloud ? getCloudInstallRequestUrl() : WARM_AGENTS_PLUGIN_PAGE_URL
  const installLabel = isCloud ? 'Request to install plugin' : 'Learn more & Install plugin'

  const learnMoreHref = isCloud ? WARM_AGENTS_PLUGIN_PAGE_URL : WARM_AGENTS_LEARN_MORE_URL
  const learnMoreLabel = 'Learn more'

  return (
    <Banner
      className={styles.banner}
      title="Reduce build queue time with Warm Agents"
      mode="info"
      withIcon
      onClose={dismiss}
    >
      {
        'Install the Warm Agents plugin to keep a configured number of cloud agents running and ready to start builds immediately. '
      }
      <Link href={installHref} target="_blank" rel="noreferrer">
        {installLabel}
      </Link>
      {learnMoreHref != null && (
        <>
          {' · '}
          <Link href={learnMoreHref} target="_blank" rel="noreferrer">
            {learnMoreLabel}
          </Link>
        </>
      )}
    </Banner>
  )
})
WarmAgentsPromoBanner.displayName = 'WarmAgentsPromoBanner'
export default WarmAgentsPromoBanner
